import { PropsWithChildren } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { ResponsiveTable, SimpleCell } from '../../ResponsiveTable';
import { CubeChartBaseProps } from '../CubeChart.types';

import { formatTableData } from './CubeChartTable.util';

export const CubeChartTable = <TData extends Record<string, any>>({
  resultSet,
  pivotConfig,
}: PropsWithChildren<CubeChartBaseProps<TData>>) => {
  const [tableColumns, rows] = useDeepCompareMemo(() => {
    const columns = resultSet.tableColumns(pivotConfig);
    const columnWidth = 100 / columns.length;
    return [
      columns.map((column) => ({
        id: column.key,
        path: [column.key],
        sx: {
          flexBasis: {
            xs: `100%`,
            sm: `${columnWidth}%`,
          },
        },
        HeadCell: SimpleCell,
      })),
      formatTableData(columns, resultSet.tablePivot(pivotConfig)),
    ];
  }, [resultSet, pivotConfig]);

  return <ResponsiveTable columns={tableColumns} rows={rows} loading={false} />;
};
